export const toPrice = (price: number, scale: number) =>
  String(((price * 100) / 100).toFixed(scale || 2))
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

export const priceUnmask = (value: string) => {
  const valueFormat = Number(
    value.replace('R$', '').replace(/[.]/g, '').replace(',', '.'),
  );
  return valueFormat;
};

export function isOver18(birthDate: string) {
  let [day, month, year] = birthDate.split('/');
  let birth = new Date(Number(year), Number(month) - 1, Number(day));

  let today = new Date();

  let age = today.getFullYear() - birth.getFullYear();

  let isBirthdayPassed =
    today.getMonth() > birth.getMonth() ||
    (today.getMonth() === birth.getMonth() &&
      today.getDate() >= birth.getDate());

  if (!isBirthdayPassed) {
    age--;
  }

  return age >= 18;
}
